import { Component, Input, OnDestroy, Output, EventEmitter } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { CommonModule, } from '@angular/common';
import { debounceTime, distinctUntilChanged, Subject, switchMap, takeUntil, finalize, startWith } from 'rxjs';
import { IPerson } from '../../models/person.model';
import { PersonService } from '../../services/common/person.service';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

@Component({
  selector: 'app-person-search',
  standalone: true,
  imports: [MatIconModule, ReactiveFormsModule, CommonModule, MatAutocompleteModule, MatFormFieldModule, MatProgressSpinnerModule],
  templateUrl: './person-search.component.html',
  styleUrl: './person-search.component.scss'
})

export class PersonSearchComponent implements OnDestroy {
  @Input() customPlaceholder: string;

  @Output() onPersonSelectedEvent = new EventEmitter<any>();
  @Output() onPersonClearEvent = new EventEmitter<any>();

  private destroy$ = new Subject<void>();
  myControl = new FormControl();
  private personSubject = new Subject<Partial<IPerson>>();
  isLoading = false;

  constructor(
    private personService: PersonService) {
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  searchPerson(query: string): void {
    query = query.trim();
    if (query.length < 3) return;
  
    const searchParams = this.prepareSearchParams(query);
  
    this.personSubject.next(searchParams);
  }

  onPersonSelected(person: IPerson): void {
    this.onPersonSelectedEvent.emit(person);
  }
 
  clearInput(){
    this.onPersonClearEvent.emit();
    this.myControl.setValue('');
    this.isLoading = false;
  }

  public person$ = this.personSubject.pipe(
    takeUntil(this.destroy$),
    debounceTime(250),
    distinctUntilChanged(),
    switchMap(person => {
      this.isLoading = true;
      return this.personService.searchPerson(person.firstName, person.surName, person.id).pipe(
        finalize(() => this.isLoading = false)
      );
    })
  );

  displayPerson(person: IPerson): string {
    return person?.fullName;
  }
  
  prepareSearchParams(query: string): Partial<IPerson> {
    const isIdSearch = !isNaN(+query);
    const hasSpace = query.indexOf(' ') > -1;
  
    return isIdSearch
      ? { id: +query }
      : hasSpace
      ? { firstName: query.split(' ')[0], surName: query.split(' ')[1] }
      : { surName: query };
  }
}